export const COMPANY_BIKE_IDENTIFIER = 'Firmenrad';
export const DEALER_BIKE_IDENTIFIER = 'Händlerrad';

export function isCompanyBike(employee: { firstName?: string; lastName?: string }): boolean {
  return employee.firstName === COMPANY_BIKE_IDENTIFIER && employee.lastName === COMPANY_BIKE_IDENTIFIER;
}

export function isDealerBike(employee: { firstName?: string; lastName?: string }): boolean {
  return employee.firstName === DEALER_BIKE_IDENTIFIER && employee.lastName === DEALER_BIKE_IDENTIFIER;
}

export function isCompanyOrDealerBike(employee: { firstName?: string; lastName?: string }): boolean {
  return isCompanyBike(employee) || isDealerBike(employee);
}
